import { AsyncPipe } from "@angular/common";
import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
} from "@angular/forms";
import {
  HardBaseFormControlComponent,
  HardBtnComponent,
  HardCalendarType,
  HardFormFieldTypeEnum,
  HardFormModule,
  HardTranslatePipe,
  IHardFormCalendarParams,
  IHardFormField,
} from "@hardcode-kz/ui";
import { SettingTypeEnum } from "@models/core/setting";
import { TranslateModule } from "@ngx-translate/core";
import { filter, Observable, skip, startWith, takeWhile } from "rxjs";

@Component({
  selector: "app-admin-settings-type-field",
  standalone: true,
  imports: [
    AsyncPipe,
    HardFormModule,
    TranslateModule,
    HardBtnComponent,
    ReactiveFormsModule,
    HardTranslatePipe,
  ],
  templateUrl: "./admin-settings-type-field.component.html",
  styleUrl: "./admin-settings-type-field.component.scss",
})
export class AdminSettingsTypeFieldComponent
  extends HardBaseFormControlComponent
  implements OnInit, OnDestroy
{
  private fb = inject(FormBuilder);

  calendar: IHardFormField<IHardFormCalendarParams> = {
    name: "value",
    type: HardFormFieldTypeEnum.Calendar,
    value: {
      startDate: "",
    },
    params: {
      calendar: {
        date: {
          startDate: "",
        },
        options: {
          type: HardCalendarType.DatePicker,
          timePicker: true,
        },
      },
    } as IHardFormCalendarParams,
  };

  type$: Observable<SettingTypeEnum>;
  componentActive = true;
  settingsType = SettingTypeEnum;
  arrayForm: FormArray<FormControl>;

  ngOnInit(): void {
    this.type$ = this.form
      .get("dataType")
      .valueChanges.pipe(startWith(this.form.get("dataType").value));

    this.type$
      .pipe(
        skip(1),
        takeWhile(() => this.componentActive),
      )
      .subscribe((type) => {
        type === SettingTypeEnum.Array
          ? this.form.setControl("value", this.fb.array([]), { emit: false })
          : this.form.setControl(
              "value",
              this.fb.control(this.form.get("value")?.value ?? null),
            );
      });

    this.type$
      .pipe(
        takeWhile(() => this.componentActive),
        filter((type) => type === SettingTypeEnum.Array),
      )
      .subscribe(() => {
        this.arrayForm = this.form.get("value") as FormArray<FormControl>;
      });
  }

  override ngOnDestroy(): void {
    this.componentActive = false;
  }

  removeControl(index: number): void {
    this.arrayForm.removeAt(index);
  }

  addControl(): void {
    this.arrayForm.push(this.fb.control(""));
  }
}
